import _slicedToArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function getPositionStyles(_ref, containerWidth, spacing) {
  var _ref2 = _slicedToArray(_ref, 2),
      vertical = _ref2[0],
      horizontal = _ref2[1];

  var styles = {};
  vertical === "top" && (styles.top = spacing);
  vertical === "bottom" && (styles.bottom = spacing);
  horizontal === "left" && (styles.left = spacing);
  horizontal === "right" && (styles.right = spacing);
  horizontal === "center" && (styles.left = "calc(50% - ".concat(containerWidth / 2, "px)"));
  return styles;
}

export default getPositionStyles;